import React, { useEffect, useState } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";
import {
  getAllEventSchedules,
  getEventScheduleById,
} from "app/_services/ehs/ehsEventScheduleServices";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import BackBtn from "app/Components/CommanComponents/BackBtn";
import { DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FaInfo } from "react-icons/fa";
import { MEETING_STATUS_VIEW, OHSE_ROLE_LIST_VIEW } from "./CONSTANT";

const initialForm = {
  scheduleId: "",
  eventId: "",
  date: "",
  venue: "",
  ownerId: "",
  type: "",
  agenda: "",
  meetingGroupIds: [],
};

const ViewScheduler = ({
  match: {
    params: { id, siteId },
  },
}) => {
  const [form, setForm] = useState({ ...initialForm });
  const [participants, setParticipants] = useState([]);
  const [getSchedule, setGetSchedule] = useState([]);
  const [previousMeeting, setPreviousMeeting] = useState({});
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!id) return;

    getEventScheduleById(id).then((response) => {
      if (!response?.data) return;

      setForm(response.data);
      setParticipants(response.data.participants);
    });
  }, [id]);

  useEffect(() => {
    getAllEventSchedules().then((response) => {
      setGetSchedule(response?.data);
    });
  }, []);

  useEffect(() => {
    const obj = getSchedule?.find((d) => d.id === form?.previousMeetingID);
    setPreviousMeeting(obj || {});
  }, [form?.previousMeetingID, getSchedule]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "OHSE Review",
            path: "/health-safety-and-environment/audits-meetings",
          },
          //   {
          //     name: "My Approval History",
          //     path: "/health-safety-and-environment/audits-meetings/my-approval-history",
          //   },
          {
            name: "View",
          },
        ]}
      />
      {/* <Breadcrumb
                routeSegments={[
                    { name: "Health Safety And Environment", path: "#" },
                    { name: "OHSE", path: (siteId ? `/sites/${siteId}` : "") + "/health-safety-and-environment/audits-meetings/manage-events" },
                    { name: "Schedule Event" },
                ]}
            /> */}
      <div className="card p-3 mt-4 overflow-inherit">
        <div className="simple-card-title title-overflowInherit">
          <h3 class="text-capitalize mb-0">View Scheduled Meeting</h3>
          <BackBtn />
        </div>
        <div className="ehsFormWrapper">
          <Row>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Id</h5>
                <p>{form?.scheduleId}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Type</h5>
                <p>{form?.event?.name}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Level</h5>
                <p>{form?.event?.meetingLabel}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Site Name</h5>
                <p>{form?.site?.name}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Venue</h5>
                <p>{form?.venue}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Date & Time</h5>
                <p>{DDMMYYYYHHMMAFormat(form?.date)}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Reference Document Description</h5>
                <p>{form?.refDocumentDescription}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Remakrs</h5>
                <p>{form?.remarks}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Time Stamp</h5>
                <p>{DDMMYYYYHHMMAFormat(form?.actualDate)}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Previous Meeting Reference</h5>
                <p>{form?.previousMeetingReference}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Scheduler</h5>
                <p>
                  {form?.scheduler
                    ? OHSE_ROLE_LIST_VIEW[form?.scheduler]
                    : OHSE_ROLE_LIST_VIEW[form?.event?.scheduler]}
                </p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Reviewer</h5>
                <p>
                  {form?.event?.reviewer
                    ? OHSE_ROLE_LIST_VIEW[form?.event?.reviewer]
                    : "Not Applicable"}
                </p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Approver</h5>
                <p>
                  {form?.approver
                    ? OHSE_ROLE_LIST_VIEW[form?.approver]
                    : OHSE_ROLE_LIST_VIEW[form?.event?.approver]}
                </p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Country</h5>
                <p>{form?.site?.state?.country_master?.name}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">State</h5>
                <p>{form?.site?.state?.name}</p>
              </div>
            </Col>
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Status</h5>
                <p>{MEETING_STATUS_VIEW[form?.eventStatus]}</p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Previous Meeting ID</h5>
                <p>
                  {previousMeeting?.event?.name} - {previousMeeting?.scheduleId}{" "}
                </p>
              </div>
            </Col>
            <Col lg={12}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">
                  Meeting Agenda (Brief){" "}
                  <CustomTooltip tooltip="Meeting Agenda (Details)">
                    <span
                      className="icons font-20 text-cyanBlue"
                      onClick={() => setShowModal(true)}
                    >
                      <FaInfo />
                    </span>
                  </CustomTooltip>
                </h5>
                <p>{form?.agenda}</p>
              </div>
            </Col>
            <Col lg={12}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Participants</h5>
                <div className="table-responsive">
                  <table id="user_table" className="table table-bordered mb-3">
                    <thead>
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">Participant Category</th>
                        <th scope="col">Participant Name</th>
                        <th scope="col">Participant Email</th>
                        <th scope="col">Participant Attendance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {participants.map((user, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            {user.category
                              ? user.category === "contractorPerson"
                                ? "Contractor Staff"
                                : user.category
                              : ""}
                          </td>
                          <td>{user.name}</td>
                          <td>{user.email}</td>
                          <td>{user.attended}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        backdrop="static"
        size="lg"
      >
        <div className="card" style={{ overflow: "visible" }}>
          <div className="card-body">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">Meeting Agenda (Details)</h3>
            </div>

            <Row className="mb-3">
              <Col lg={12}>
                <div className="form-group viewbox">
                  {/* <h5 className="w-500 mb-1">Meeting Agenda (Brief)</h5> */}
                  <p dangerouslySetInnerHTML={{ __html: form?.detailedAgenda }}></p>
                  {/* <span className="small text-danger">{errorForm.agenda}</span> */}
                </div>
              </Col>
            </Row>

            <div className="mt-2 text-center">
              <Button
                onClick={() => {
                  setShowModal(false);
                }}
                className="btn btn-secondary mr-2"
              >
                Close
              </Button>
              {/* 
                <Button onClick={onSubmit} type="submit" variant="primary" className="m-1 text-capitalize">
                  Save
                </Button> */}
            </div>
          </div>
        </div>
      </Modal>
      {/* <div className="mt-2">
                <LogHistory refrenceId={id} subModulename="ehsEventSchedule" />
            </div> */}
    </div>
  );
};

export default ViewScheduler;
